import React, { useState, useEffect } from 'react';
import { useStateValue } from './StateProvider.js';
import axios from 'axios';
import configData from './Config';
import Spinner from './Spinner.js';

import Header from './Header.js';

import './Accountants.css';

function Accountants({ state, setState }) {
    const [{ projects }, dispatch] = useStateValue();

    const [search, setSearch] = useState('');
    const [accountants, setAccountants] = useState([]);

    const [loading, setLoading] = useState(false);

    const handleCloseModal = () => {
        setState(state => ({ ...state, modalopen: false, modalcontent: null, modaltype: null, modaltitle: null }));
    }

    const handleViewButton = (accountant) => {
        console.log(accountant)
        setState(state => ({ ...state, modalopen: true, modalcontent: <ViewAccountant accountant={accountant} />, modaltype: 'small', modaltitle: 'View Accountant' }));
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            handleSearch(search);
        }, 700);

        return () => clearTimeout(handler);
    }, [search]);

    const handleSearch = (text) => {
        console.log('Trying to get accountants');
        setLoading(true);

        const data = {
            search: text
        };

        axios.post(configData.CONTROLLERURL + configData.GETACCOUNTANTS, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8"
            }
        }).then((res) => {
            console.log('Accountants data received');
            console.log(res.data);
            if (res.data instanceof Array) {
                setAccountants(res.data)
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setLoading(false);
        });
    };

    function ViewAccountant({ accountant }) {
        const [name, setName] = useState('');
        const [country, setCountry] = useState('');
        const [email, setEmail] = useState('');
        const [contact, setContact] = useState('');

        useEffect(() => {
            setName(accountant.name);
            setCountry(accountant.country);
            setEmail(accountant.email);
            setContact(accountant.contact);
        }, [accountant])

        return (
            <div className='modal_body'>
                <div className='modal_printable'>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Name</div>
                        </div>
                        <div className='modal_rowsection'>{name}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Country</div>
                        </div>
                        <div className='modal_rowsection'>{country}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Email</div>
                        </div>
                        <div className='modal_rowsection'>{email}</div>
                    </div>
                    <div className='modal_row'>
                        <div className='modal_rowsection'>
                            <div className='modal_label'>Contact</div>
                        </div>
                        <div className='modal_rowsection'>{contact}</div>
                    </div>
                </div>
                <div className='modal_actions'>
                    <div className='modal_buttons'>
                        <div className='modal_buttoncontainer'>
                            <button className='modal_button' onClick={handleCloseModal}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className='accountants'>
            <Header state={state} setState={setState} />

            <div className='accountants_title'>
                Affiliated Accountants
            </div>
            <div className='accountants_titlecaption'>
                Discover trusted accountants and bookkeepers near you — professionals with the skills and experience to manage your finances confidently.
            </div>

            <div className='accountants_buttonscontainer'>
                <input
                    type="text"
                    className="accountants_input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search..."
                />
            </div>

            {
                loading ?
                    <div className='accountants_spinner'>
                        <Spinner loading={loading} size={30} />
                    </div>
                    :
                    accountants.length > 0 && (
                        accountants.map((accountant, index) => (
                            <div
                                key={'accountant' + index}
                                className='accountants_card'
                                onClick={() => handleViewButton(accountant)}
                            >
                                <div className='accountants_cardname'>{accountant.name}</div>
                                <div className='accountants_cardcountry'>{accountant.country}</div>
                            </div>
                        ))
                    )
            }
        </div>
    );
}

export default Accountants;